import { provideGlobalGridOptions } from 'ag-grid-community';
import { LicenseManager as LicenseManagerGrid, ModuleRegistry, ValidationModule } from 'ag-grid-enterprise';
import { LicenseManager as LicenseManagerCharts } from 'ag-charts-enterprise';

import { getRuntimeConfig } from '@/lib/runtimeConfig';

// The validation module keeps its detailed console warnings in every build. Its on-screen diagnostics
// panel (shown over the rows on every deprecation, warning and error by default) is for developers,
// so production builds — deployed dev and staging included — switch it off.
const validationModule =
  process.env.NODE_ENV === 'production' ? ValidationModule.with({ showOverlayOn: [] }) : ValidationModule;

const agGridLicenseInitializer = () => {
  const licenseKey = getRuntimeConfig().env.REACT_APP_AG_GRID_LICENSE;
  ModuleRegistry.registerModules([validationModule]);
  // Filter handlers for every grid, detail grids included: the grid keeps each column filter's model itself, so a
  // model set before the filter's popup was ever opened (a saved layout, a chip, `setFilterModel`) is in force for
  // the next rows request. Off by default in AG Grid 36. Read once when a grid is created, so this runs before any
  // grid exists; a grid's own option would win. Custom filter components edit the model through
  // `useGridFilterDisplay`; client-side grids test rows through the column's `filter.doesFilterPass`.
  // One call site: a second `provideGlobalGridOptions` replaces these options instead of adding to them.
  provideGlobalGridOptions({ enableFilterHandlers: true });
  LicenseManagerGrid.setLicenseKey(licenseKey);
  LicenseManagerCharts.setLicenseKey(licenseKey);
};

export default agGridLicenseInitializer;
